export default __webpack_public_path__ + "static/media/glowDot.9277dc80.webp";